export default import.meta.ROLLDOWN_FILE_URL_Xd4k8iqlgO9Qh7DVpcdd0g